import {AutogenLayoutRateIndexAdditionalOptionsPanel} from "./autogen/AutogenLayoutRateIndexAdditionalOptionsPanel";

export class RateIndexAdditionalOptionsPanel extends AutogenLayoutRateIndexAdditionalOptionsPanel{

    async onLoad() {

    }


}
